export enum EducationLevel {
  None = 'NONE',
  School = 'SCHOOL',
  Apprentice = 'APPRENTICE',
  Tech = 'TECH',
  Academic = 'ACADEMIC',
}
